import React, { createContext } from 'react';

type ContextType = {
  nativeError?: Error;
  setNativeError: React.Dispatch<React.SetStateAction<Error | undefined>>;
};

const defaultContext: ContextType = {
  nativeError: undefined,
  setNativeError() {}
};

const ErrorContext = createContext<ContextType>(defaultContext);

export function ErrorContextProvider(props: React.PropsWithChildren<{}>) {
  const [nativeError, setNativeError] = React.useState<Error | undefined>(
    undefined
  );

  const value = React.useMemo<ContextType>(
    () => ({
      nativeError,
      setNativeError
    }),
    [nativeError]
  );

  return (
    <ErrorContext.Provider value={value}>
      {props.children}
    </ErrorContext.Provider>
  );
}

ErrorContextProvider.displayName = 'ErrorContextProvider';

export default ErrorContext;
